"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptNumber = exports.indexOfFirstVowel = exports.normalizeVowels = exports.normalizeConsonants = exports.normalizeAccentedVowel = exports.normalizeTilde = exports.formatDecimalFraction = exports.normalizeFraction = exports.normalizeNumber = exports.normalizeSign = void 0;
var normalizeSign = function (sign) {
    var normalizedSign = (0, exports.normalizeConsonants)(sign);
    normalizedSign = (0, exports.normalizeVowels)(normalizedSign);
    return normalizedSign;
};
exports.normalizeSign = normalizeSign;
var normalizeNumber = function (num) {
    var normalizedNum = num;
    if (num.match(/^\d$/)) {
        normalizedNum = "".concat(normalizedNum.charAt(0), "DI\u0160");
    }
    else if (num.match(/^\d0$/)) {
        normalizedNum = "".concat(normalizedNum.charAt(0), "U");
    }
    else if (num.match(/^\d{2}$/)) {
        normalizedNum = "".concat(normalizedNum.charAt(0), "U+").concat(normalizedNum.charAt(1), "DI\u0160");
    }
    else if (num.match(/^\d{2}AŠ/)) {
        normalizedNum = "".concat(normalizedNum.charAt(0), "U+").concat(normalizedNum.charAt(1), "A\u0160");
    }
    else if (num.match(/^\d{2}DIŠ/)) {
        normalizedNum = "".concat(normalizedNum.charAt(0), "U+").concat(normalizedNum.charAt(1), "DI\u0160");
    }
    return normalizedNum;
};
exports.normalizeNumber = normalizeNumber;
var normalizeFraction = function (num) {
    switch (num) {
        case '1/2':
            return '½';
        case '1/3':
            return '⅓';
        case '1/4':
            return '¼';
        case '1/5':
            return '⅕';
        case '1/6':
            return '⅙';
        case '2/3':
            return '⅔';
        case '3/4':
            return '¾';
        case '5/6':
            return '⅚';
        default:
            return num;
    }
};
exports.normalizeFraction = normalizeFraction;
var FRACTION_GLYPHS = [
    [1 / 6, '⅙'],
    [1 / 5, '⅕'],
    [1 / 4, '¼'],
    [1 / 3, '⅓'],
    [1 / 2, '½'],
    [2 / 3, '⅔'],
    [3 / 4, '¾'],
    [5 / 6, '⅚'],
];
var formatDecimalFraction = function (reading) {
    if (!/^\d+\.\d+$/.test(reading)) {
        return reading;
    }
    var value = Number(reading);
    var whole = Math.floor(value);
    var match = FRACTION_GLYPHS.find(function (_a) {
        var fraction = _a[0];
        return Math.abs(fraction - (value - whole)) < 0.001;
    });
    if (!match) {
        return reading;
    }
    return "".concat(whole || '').concat(match[1]);
};
exports.formatDecimalFraction = formatDecimalFraction;
var normalizeTilde = function (sign) {
    var firstVowelIndex = (0, exports.indexOfFirstVowel)(sign);
    if (firstVowelIndex >= 0) {
        var vowel = sign[firstVowelIndex];
        var number = Number(sign[sign.length - 1]);
        var correctedVowel = (0, exports.normalizeAccentedVowel)(vowel, number);
        sign = sign.replace(vowel, correctedVowel);
        sign = sign.slice(0, -1);
    }
    return sign;
};
exports.normalizeTilde = normalizeTilde;
var normalizeAccentedVowel = function (vowel, number) {
    var idx = number - 1;
    switch (vowel) {
        case 'a':
            return ['a', 'á', 'à'][idx];
        case 'e':
            return ['e', 'é', 'è'][idx];
        case 'i':
            return ['i', 'í', 'ì'][idx];
        case 'o':
            return ['o', 'ó', 'ò'][idx];
        case 'u':
            return ['u', 'ú', 'ù'][idx];
        case 'A':
            return ['A', 'Á', 'À'][idx];
        case 'E':
            return ['E', 'É', 'È'][idx];
        case 'I':
            return ['I', 'Í', 'Ì'][idx];
        case 'O':
            return ['O', 'Ó', 'Ò'][idx];
        case 'U':
            return ['U', 'Ú', 'Ù'][idx];
        default:
            return vowel;
    }
};
exports.normalizeAccentedVowel = normalizeAccentedVowel;
var normalizeConsonants = function (sign) {
    var newSign = sign.replace(/sz/g, 'š');
    newSign = newSign.replace(/s,/g, 'ṣ');
    newSign = newSign.replace(/t,/g, 'ṭ');
    newSign = newSign.replace(/SZ/g, 'Š');
    newSign = newSign.replace(/S,/g, 'Ṣ');
    newSign = newSign.replace(/T,/g, 'Ṭ');
    newSign = newSign.replace(/h/g, 'ḫ');
    newSign = newSign.replace(/H/g, 'Ḫ');
    return newSign;
};
exports.normalizeConsonants = normalizeConsonants;
var normalizeVowels = function (sign) {
    var normalizedSign = sign.split('');
    var isSingleDigitRegex = /^\D+[1-3]$/;
    if (sign.match(isSingleDigitRegex)) {
        return (0, exports.normalizeTilde)(sign);
    }
    if (!sign.match(/^\d+$/)) {
        [1, 2].forEach(function (negIdx) {
            var signIdx = normalizedSign.length - negIdx;
            if (normalizedSign.length >= negIdx && isDigit(normalizedSign[signIdx])) {
                normalizedSign[signIdx] = (0, exports.subscriptNumber)(normalizedSign[signIdx]);
            }
        });
    }
    return normalizedSign.join('');
};
exports.normalizeVowels = normalizeVowels;
var indexOfFirstVowel = function (sign) {
    var splitSign = sign.split('');
    var vowels = 'AÁÀEÉÈIÍÌOÓÒUÚÙaáàeéèiíìoóòuúù'.split('');
    var firstVowel = splitSign.find(function (char) { return vowels.includes(char); });
    if (firstVowel) {
        return splitSign.indexOf(firstVowel);
    }
    return -1;
};
exports.indexOfFirstVowel = indexOfFirstVowel;
var isDigit = function (char) { return !!char.match(/^\d$/); };
var subscriptNumber = function (normalNumber) {
    return String.fromCharCode(8320 + Number(normalNumber));
};
exports.subscriptNumber = subscriptNumber;
//# sourceMappingURL=signNormalizer.js.map